// extracted by mini-css-extract-plugin
module.exports = {"montserrat":"fonts_montserrat__M2XVa"};